import { EuiSelectOption } from '@equipmentshare/ds2'
import ReasonPicker, { ReasonPickerProps } from 'components/ReasonPicker'
import { useCallback } from 'react'
import { ManualAdjustmentReasonType } from '../../../../graphql'
import { useFlags } from '@equipmentshare/feature-flags'
import useCanCreateEcommerceAdjustment from 'hooks/useCanCreateEcommerceAdjustment'
import useEcommAdjustmentFlag from 'hooks/useEcommAdjustmentFlag'
import useCanCreateRefurbishedAdjustment from 'hooks/useCanCreateRefurbishedAdjustment'
import useRefurbishedAdjustmentFlag from 'hooks/useRefurbishedAdjustmentFlag'

export type ReasonSelectProps = ReasonPickerProps & {
	storeId?: number,
	branchId?: string | null,
}

export default function ReasonSelect( { storeId, branchId, ...props }: ReasonSelectProps ) {
	const flags = useFlags()
	const ecommAdjustmentEnabled = useEcommAdjustmentFlag( branchId )
	const canCreateEcommerceAdjustment = useCanCreateEcommerceAdjustment( storeId )
	const refurbishedAdjustmentEnabled = useRefurbishedAdjustmentFlag( branchId )
	const canCreateRefurbishedAdjustment = useCanCreateRefurbishedAdjustment( storeId )
	const filterOptions = useCallback( ( option: EuiSelectOption ) => {
		if ( !flags.enableTswCreditCardAdjustment && option.value === ManualAdjustmentReasonType.CreditCardPurchase ) {
			return false
		}

		if (
			option.value === ManualAdjustmentReasonType.EcommercePartsReturn &&
			!( ecommAdjustmentEnabled && canCreateEcommerceAdjustment )
		) {
			return false
		}

		if (
			option.value === ManualAdjustmentReasonType.RefurbishedPart &&
			!( refurbishedAdjustmentEnabled && canCreateRefurbishedAdjustment )
		) {
			return false
		}

		return true
	}, [ flags, ecommAdjustmentEnabled, canCreateEcommerceAdjustment, refurbishedAdjustmentEnabled, canCreateRefurbishedAdjustment ] )
	return (
		<ReasonPicker
			filterOptions={filterOptions}
			{...props}
		/>
	)
}
